module.exports = __webpack_public_path__ + "static/media/storm.073efb66.mp3";